var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MarkAsSeenButtonView,{attrs:{"saving":_setup.savingStatus,"isMarked":_vm.isTitleSeen},on:{"mark-as-seen-button-click":_setup.handleMarkAsSeen}})
}
var staticRenderFns = []

export { render, staticRenderFns }